<template>
    <div class="window window-disclaimer border-primary" v-show="selectedZipLatLng" :style="cssStyle">
        <div class="window-heading bg-primary" @mousedown="dragStart" @mousemove="dragging" @mouseup="dragStop" @mouseout="dragStop">
            <button type="button" class="btn btn-close" @click="clearSelectedZip">&times;</button>
            My location
        </div>
        <div class="window-body">
            <div>
                Showing
                <em>{{ selectedStatistic.label }}</em>
                in year <em>{{ queryYear }}</em>
                for five transplant centers closest to you.
            </div>
            <div class="list">
                <div
                        class="item"
                        v-for="(txCenter, index) in txValues"
                        :key="index">
                    <div class="tx-name">
                        {{ txCenter.name }}:
                        <span class="tx-stat"><em>{{ txCenter['value'] }}</em></span>
                    </div>
                    <div class="tx-distance">
                        {{ Math.round(txCenter.distance * 0.00062137) }} miles away
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statFun from '../../api/txc'
import { mapGetters } from 'vuex'
import ZipInsightPanel from '../ZipInsightPanel'

export default {
  name: 'ZipInsightWindow',

  components: { ZipInsightPanel },

  computed: {
    ...mapGetters({
      allLegends: 'allLegends',
      google: 'google',
      queryOrganMode: 'queryOrganMode',
      queryRegionMode: 'queryRegionMode',
      queryStatisticId: 'queryStatisticId',
      queryStatisticSubId: 'queryStatisticSubId',
      queryYear: 'queryYear',
      selectedStatistic: 'selectedStatistic',
      selectedZip: 'selectedZip',
      selectedZipClosestTxCenters: 'selectedZipClosestTxCenters',
      selectedZipLatLng: 'selectedZipLatLng',
      txCenters: 'txCenters',
      txRecords: 'txRecords'
    }),

    cssStyle: function () {
      return {
        top: this.y + 'px',
        left: this.x + 'px'
      }
    }
  },

  data: function () {
    return {
      isDragging: false,
      x: -1,
      y: -1,
      txValues: []
    }
  },

  methods: {
    clearSelectedZip (event) {
      event.stopPropagation()
      this.$store.commit('selectZip', null)
      this.$store.commit('setSelectedZipLatLng', null)
    },

    computeList: function () {
      // Copy array
      this.txValues = this.selectedZipClosestTxCenters.slice()

      // Calculate statistic value for selectedZipClosestTxCenters
      let query = {
        organMode: this.queryOrganMode,
        regionMode: this.queryRegionMode,
        year: this.queryYear
      }
      let selectedStatistic = this.selectedStatistic
      let txRecords = this.txRecords
      let statId = 'tx_stat_' + this.selectedStatistic.value
      let statUnit = this.allLegends[selectedStatistic.legend].unit
      this.selectedZipClosestTxCenters.forEach(function (txCenter) {
        let txId = txCenter.tx_ctr_id
        let txData = statFun[statId](txRecords, query, txId)
        let yearIndex = txData.years.indexOf(query.year)
        if (isNaN(txData.hist[yearIndex])) {
          txCenter['value'] = 'n/a'
          txCenter['value_numeric'] = -1
        } else if (selectedStatistic.legend === 'percent') {
          txCenter['value'] = Math.round(100 * txData.hist[yearIndex]) + '%'
          txCenter['value_numeric'] = txData.hist[yearIndex]
        } else {
          let precision = selectedStatistic.unit_precision || 1
          txCenter['value'] = Math.round(precision * txData.hist[yearIndex]) / precision + ' ' + statUnit
          txCenter['value_numeric'] = txData.hist[yearIndex]
        }
      })

      // Sort by value
      this.txValues.sort(function (a, b) {
        return b.value_numeric - a.value_numeric
      })

      // Get closest 5 centers with values != n/a
      // this.txValues = this.txValues.filter(function (a) {
      //   return a.value_numeric >= 0
      // }).slice(0, 5)
    },

    dragStart: function (event) {
      this.isDragging = true
    },

    dragging: function (event) {
      if (this.isDragging) {
        this.x += event.movementX
        this.y += event.movementY
      }
    },

    dragStop: function (event) {
      this.isDragging = false
    }
  },

  mounted: function () {
    this.x = window.innerWidth / 2
    this.y = window.innerHeight / 2
    this.computeList()
  },

  watch: {
    queryOrganMode: 'computeList',
    queryRegionMode: 'computeList',
    queryStatisticId: 'computeList',
    queryStatisticSubId: 'computeList',
    queryYear: 'computeList',
    selectedZipClosestTxCenters: 'computeList'
  }
}
</script>

<style scoped>
.btn-close {
    float: right;
    border: none;
    padding: 0 .3rem;
    border-color: transparent;
}
.btn-close:hover {
    border: 1px solid #fff;
}
.window-disclaimer {
    position: fixed;
    width: 500px;
    transform: translate(-50%, -50%);
    max-width: 100%;
    background-color: #fff;
    z-index: 8000;
}
.window-body,
.window-heading,
.window-buttons {
    padding: 1rem;
}
.window-heading {
    cursor: move;
}
.item {
    margin-top: 1rem;
}

.tx-distance {
    color: #555;
    font-size: .9rem;
}
.window {
    opacity: .7;
    transition: opacity .25s;
}
.window:hover {
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/ZipInsightWindow.vue